import { FC, useState } from 'react';
import { Select, MenuItem, Typography } from '@material-ui/core';
import Goal from '../../../../entity/Goal';
import styled from '@emotion/styled';
import { SPACING_UNIT } from '../../../constant/spacing';
import GoalTypeIcon from '../LiftReportToolBar/GoalTypeIcon';

type Props = {
  selectedGoalId: string | null;
  goals?: Goal[] | null;
  onChange: (e: any) => void;
  className?: string;
};

const GoalSelector: FC<Props> = ({ selectedGoalId, goals, onChange, className }) => {
  if (!goals || goals.length === 0) {
    return null;
  }

  if (!selectedGoalId) {
    return null;
  }

  /* eslint react-hooks/rules-of-hooks:0 */
  const [goalId, setSelectedGoalId] = useState<string>(selectedGoalId);

  const onChangeSelector = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedGoalId(event.target.value as string);
    onChange(event.target.value as string);
  };

  const menuItems = goals
    .slice()
    .sort((a, b) => {
      if (parseInt(a.id) < parseInt(b.id)) return -1;
      if (parseInt(a.id) < parseInt(b.id)) return 1;
      return 0;
    })
    .map((goal) => {
      return goal.id && goal.liftReport ? (
        <GoalMenuItem value={goal.id} key={goal.id}>
          <MenuChild>
            <GoalTypeIcon type={goal.triggerType} size={28} color="#4C566C" />
            <GoalName>{goal.title}</GoalName>
            <GoalIdTypography variant="subtitle2">#{goal.id}</GoalIdTypography>
          </MenuChild>
        </GoalMenuItem>
      ) : null;
    });

  return (
    <GoalSelect variant="outlined" className={className} value={goalId} onChange={onChangeSelector}>
      {menuItems}
    </GoalSelect>
  );
};

const GoalSelect = styled(Select)({
  '& .MuiOutlinedInput-input': {
    padding: '8px 32px 8px 12px',
  },
  display: 'flex',
  alignItems: 'center',
  background: '#F5F6F7',
  borderRadius: '4px',
  width: '100%',
  height: '48px',
});

const GoalMenuItem = styled(MenuItem)({
  height: '36px',
  display: 'flex',
});

const MenuChild = styled('div')({
  display: 'flex',
});

const GoalName = styled(Typography)({
  marginLeft: SPACING_UNIT,
  display: 'flex',
  alignItems: 'center',
  color: '#4C566C',
  fontWeight: 700,
  fontSize: 14,
});

const GoalIdTypography = styled(Typography)({
  marginLeft: SPACING_UNIT,
  display: 'flex',
  alignItems: 'center',
  color: '#4C566C',
  fontSize: 12,
});

export default GoalSelector;
